import React, { useEffect, useState, useMemo } from "react"
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { Bars } from  'react-loader-spinner'

import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Typography from "@material-ui/core/Typography";
import Backdrop from "@material-ui/core/Backdrop";

import moment from "moment";
import { ErrorMessage } from '@hookform/error-message';

import { ApolloBreadcrumbs } from "../../atom/Apollo_Breadcrumbs"
import {
  ApolloEventRecord,
  ItemList,
  LogData,
  createUserLogItemListFromNumber,
  createUserLogItemListFromString,
  createUserLogItemListFromDate,
  createUserLogItemListFromObject,
  handleSuccessEventLog,
  handleFailureEventLog,
} from "../../atom/Apollo_EventRecord";
import {
  ApolloMessage,
  CustomizedSnackbars,
  setLoadingMessage,
  setSuccessMessage,
  setWarningMessage,
  setErrorMessage,
  setErrorMessageTypeAll,
} from "../../atom/Apollo_Mesasge";
import {
  apollo_useStyles,
  options_performance_report_ad_kind,
  options_performance_report_totaling_period_kind,
  options_analysis_report_totaling_period_kind,
  options_analysis_report_option,
  options_extract_period_kind,
  weekKeys,
  Option,
  StrOption,
} from "../../atom/Apollo_styles";
import {
  GroupedOption,
  ColoredOption,
  options_report_kind,
  options_extract_frequency_kind,
  options_extract_timing_kind,
  options_extract_timing_kind_without_realtime,
  options_demographic_report_extract_period_kind,
  options_extract_day,
  options_demographic_report_output_case_lebel,
  options_menu_kind_report,
  options_demographic_report_menu_kind,
  options_menu_campaign_kind,
} from "../../atom/Apollo_Options";
import { ApolloContext } from "../../atom/Apollo_Context";
import {
  apollo_account_campaign_path,
  apollo_report_setting_path,
  apollo_report_campaign_names_path,
  apollo_report_output_columns_master_path,
  apollo_setpoints_path,
  apollo_reports_path
} from "../../atom/Apollo_links";
import {
  ApolloAxios,
} from "../../atom/Apollo_ApiRequest3";
import { ApolloExpired }  from "../../atom/Apollo_Expired";
import {
  ApolloDialog,
  ApolloDialogButton,
} from "../../atom/Apollo_Dialog";
import {
  RESULT_CODE,
  MSG,
  REPORT_KIND,
  OUTPUT_CASE_LEBEL,
  AGGREGATION_UNIT,
  DEMOGRAPHIC_REPORT_KIND,
  EXTRACT_PERIOD_KIND,
  EXTRACT_FREQUENCY_KIND,
  SCHEDULE_KIND,
  REPORT_STATUS,
  NUMBER,
  MENU,
  REPEAT_STATUS,
  CHECKBOX_STATE,
  ZERO,
  BLANK,
  COMMA,
  RESULT_SETPOINT_ERROR,
  FORMAT_YYYY_MM_DD_HHmmss,
  UNDER_SCORE,
  DAY,
  INVALID_DATE,
  UNNAMED_REPORT,
  INIT_EXTRACT_WEEK,
  REPORT_SCHEDULE_END_DATE_MAX,
  REPORT_DEFAULT_SCHEDULE_END_DATE,
  DEMOGRAPHIC_REPORT_MAX_PERIOD,
  REPORT_OUTPUT_COLUMNS,
  REPORT_PERIOD_AUTO_CHANGE_MSG,
  REPORT_PERIOD_START_DEFAULT_VALUE_SET_MSG,
  REPORT_PERIOD_END_DEFAULT_VALUE_SET_MSG,
} from "../../common/Apollo_CommonConst_Beta";
import {
  sortByUnderscoreParts,
  checkInvalidCharForReportName,
} from "../../common/Apollo_CommonUtil_Beta";
import {
  ApolloBasicSelect,
  ApolloBasicTextField,
  ApolloBasicRadio,
  ApolloBasicCheck,
  ApolloBasicPeriod,
} from "../../molecule/Apollo_BaseItem";
import {
  ApolloOutputColumnDialog,
  filterOutputColumns,
  isSetOutputColumns,
} from "../../organism/REPORT/Output_Column_Dialog";
import {
  ReportSetting,
  AccountCampaign,
  CampaignList,
  ReportSettingRequest,
  ReportMenuCampaignKind,
} from "./ReportModel"
import GenericTemplate from "../../templates/GenericTemplate"
import { Buffer } from 'buffer';
import {APOLLO_PROFILE_SYSTEM_ADMIN, APOLLO_SYSTEM_ADMIN, IsAuthorization} from "../../atom/Apollo_Authorization";

// 今月初
const startThisMonth = `${moment().startOf('month').format("YYYY/MM/DD HH:mm")}:00`;
// 今月末
const endThisMonth = `${moment().endOf('month').format("YYYY/MM/DD HH:mm")}:00`;
// 翌日初
const startNextDay = `${moment().add(1, 'day').startOf('day').add(10, 'hours').format("YYYY/MM/DD HH:mm")}:00`;
// スケジュールの終了日
const scheduleEndDay = `${moment().add(REPORT_DEFAULT_SCHEDULE_END_DATE, 'day').startOf('day').format("YYYY/MM/DD HH:mm")}:00`;

const initReport: ReportSetting = {
  reportSettingId: ZERO,
  reportName: BLANK,
  accountgroupId: ZERO,
  accountgroupName: BLANK,
  accountName: BLANK,
  accountId: ZERO,
  reportKind: REPORT_KIND.PERFORMANCE,
  menuCampaignKind: [],
  status: ZERO,
  outputCaseLebel: OUTPUT_CASE_LEBEL.CAMPAIGN,
  aggregationUnit: AGGREGATION_UNIT.SUM_TOTAL,
  option: DEMOGRAPHIC_REPORT_KIND.AGE_GENDER,
  extractPeriodKind: EXTRACT_PERIOD_KIND.CURRENT_MONTH,
  extractFrequencyKind: EXTRACT_FREQUENCY_KIND.WEEKLY,
  extractDay: NUMBER.ONE,
  startAt: startThisMonth,
  endAt: endThisMonth,
  scheduleKind: SCHEDULE_KIND.REALTIME,
  extractWeek: INIT_EXTRACT_WEEK,
  scheduledAt: startNextDay,
  scheduledEndAt: scheduleEndDay,
  createdBy: BLANK,
  createdAt: BLANK,
  period: BLANK,
  modifiedBy: BLANK,
  modifiedAt: BLANK,
  repeatStatus: ZERO,
  outputColumn: REPORT_OUTPUT_COLUMNS.MASTER.join(COMMA),
};

const ReportCreate: React.FC = () => {

  // useContext
	const { state: apolloContex} = React.useContext(ApolloContext);
  const { data: msg, setmsg } = React.useContext(ApolloMessage);

  // current
  const accountGroupId = apolloContex.current.accountGroupId;
  const accountId = apolloContex.current.accountId;

  // style
  const classes = apollo_useStyles();

  // history
  const history = useHistory();
  const handleGoback = () => {
    history.goBack();
  };
  const goToReport = () => history.push(apollo_reports_path);

  // form
  const { register, handleSubmit, control, setError, errors, clearErrors, formState } = useForm({ reValidateMode: 'onBlur' });

  // useState
  const [progress, setProgress] = useState(false);
  const [report, setReport] = useState<ReportSetting>(initReport)
  const [accountCampaigns, setAccountCampaigns] = useState<AccountCampaign[]>([])
  const [campaignList, setCampaignList] = useState<CampaignList[]>([]);
  const [menuOptions, setMenuOptions] = useState<Option[]>([])
  const [campaignKindOptions, setCampaignKindOptions] = useState<StrOption[]>([])
  const [groupedCampaignOptions, setGroupedCampaignOptions] = useState<GroupedOption[]>([])
  const [selectedMenuValues, setSelectedMenuValues] = useState<number[]>([])
  const [selectedCampaignKindValues, setSelectedCampaignKindValues] = useState<string[]>([])
  const [selectedCampaignValues, setSelectedCampaignValues] = useState<any[]>([])
  const [openOutputColumnDialog, setOpenOutputColumnDialog] = useState(false);
  const [accountOptions, setAccountOptions] = useState<Option[]>([]);
  const [setPoints, setSetPoints] = useState<Option[]>([]);
  const [deletedSetPoints, setDeletedSetPoints] = useState<Option[]>([]);
  const [outputColumnsMaster, setOutputColumnsMaster] = useState<Option[]>([])

  // 開始、終了 テキストボックスコンポーネント更新用
  const [updatePriodItemTrigger, setUpdatePriodItemTrigger] = useState(moment());
  const [priodStarMessageInfo, setPriodStarMessageInfo] = useState(BLANK);
  const [priodEndessageInfo, setPriodEndessageInfo] = useState(BLANK);

  // etc
  const extractWeekJson = report.extractWeek ? JSON.parse(report.extractWeek) as number[] : [];

  const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN);
  const now = moment();

  // しきい値
  const cutoff  = moment("2025-09-30 23:59", "YYYY-MM-DD HH:mm"); // 〜9/30 23:59
  const octStart = moment("2025-10-01 00:00", "YYYY-MM-DD HH:mm"); // 10/1 0:00
  const octEnd   = moment("2025-10-31 23:59", "YYYY-MM-DD HH:mm"); // 10/31 23:59
  const oct7End  = moment("2025-10-07 23:59", "YYYY-MM-DD HH:mm"); // 10/7 23:59

  const isBeforeCutoff = !isAuthorization && now.isSameOrBefore(cutoff);                // 〜9/30 23:59
  const isInOctWindow  = !isAuthorization && now.isBetween(octStart, octEnd, null, "[]"); // 10/1〜10/31

  // キャンペーン種別の選択肢からリアルタイムメッセージSを非表示にするために用意
  const optionsMenuCampaignKindRTMValue = "2_2"

  // --- 作成タイミング（scheduleKind）候補を期間でフィルタ ---
  // value: 3=即時, 2=日時指定, 1=繰り返し
  const scheduleKindOptions = useMemo(() => {
    const base =
      report.reportKind === REPORT_KIND.DEMOGRAPHIC
        ? options_extract_timing_kind_without_realtime
        : options_extract_timing_kind;

    if (isBeforeCutoff) {
      // 9/30 23:59 以前：即時(3)を隠す＝日時指定(2)・繰り返し(1)のみ
      return base.filter((o: any) => [1, 2].includes(o.value));
    }
    // 10/1〜10/31：表示は制限なし（※DEMOGRAPHICは元々「即時」なしの定義）
    return base;
  }, [report.reportKind, isBeforeCutoff]);

  // 表示候補から外れたら「選択できる一番最初の要素」に自動補正
  useEffect(() => {
   if (!scheduleKindOptions || scheduleKindOptions.length === 0) return;
   const isInOptions = scheduleKindOptions.some(
     (o: any) => o.value === report.scheduleKind
   );
   if (!isInOptions) {
     const firstValue = scheduleKindOptions[0].value;
     setReport((prev) => ({ ...prev, scheduleKind: firstValue }));
   }
  }, [scheduleKindOptions, report.scheduleKind]);

  const effectiveScheduleKind = useMemo(() => {
     if (!scheduleKindOptions || scheduleKindOptions.length === 0) {
       return report.scheduleKind;
     }
     const exists = scheduleKindOptions.some((o: any) => o.value === report.scheduleKind);
     return exists ? report.scheduleKind : scheduleKindOptions[0].value;
   }, [scheduleKindOptions, report.scheduleKind]);

   // state も同期（初期表示から選択状態が付く）
   useEffect(() => {
     if (effectiveScheduleKind !== report.scheduleKind) {
       setReport(prev => ({ ...prev, scheduleKind: effectiveScheduleKind }));
     }
   }, [effectiveScheduleKind]);

  // --- 期間指定（extractPeriodKind）候補を制限 ---
  // value: 1=当月, 2=前月, 3=前日, 4=過去7日間, 5=カスタム
  const baseExtractOptions =
    report.reportKind === REPORT_KIND.PERFORMANCE
      ? options_extract_period_kind
      : options_demographic_report_extract_period_kind;

  const extractPeriodOptions = useMemo(() => {
    let opts = baseExtractOptions;

    // 10/1〜10/31 かつ 作成タイミング=即時(3) のときだけ追加制限
    if (report.scheduleKind === 3 && isInOctWindow) {
      const disallow = new Set<number>();

      // 10/31 までは「前月」(2) 不可
      disallow.add(2);

      // 10/1 は「前日」(3) 不可
      if (now.isSame(octStart, "day")) disallow.add(3);

      // 10/7 までは「過去7日間」(4) 不可
      if (now.isSameOrBefore(oct7End)) disallow.add(4);

      opts = opts.filter((o: any) => !disallow.has(o.value));
    }

    if (!isAuthorization && report.scheduleKind === SCHEDULE_KIND.SCHEDULED) {
      const sa = moment(report.scheduledAt);
      if (sa.isValid()) {
        const disallow = new Set<number>();
        // 日付指定が 〜10/31 なら「前月(2)」不可
        if (sa.isSameOrBefore(octEnd)) disallow.add(EXTRACT_PERIOD_KIND.LAST_MONTH);
        // 日付指定が 10/1 なら「前日(3)」不可（※DEMOGRAPHIC にはそもそも存在しないためあっても無視）
        if (sa.isSame(octStart, "day")) disallow.add(EXTRACT_PERIOD_KIND.LAST_DAY);
        // 日付指定が 〜10/7 なら「過去7日間(4)」不可
        if (sa.isSameOrBefore(oct7End)) disallow.add(EXTRACT_PERIOD_KIND.LAST_SEVEN_DAYS);

        if (disallow.size > 0) {
          opts = opts.filter((o: any) => !disallow.has(o.value));
        }
      }
    }
    return opts;
  }, [
    baseExtractOptions,
    report.reportKind,
    report.scheduleKind,
    report.scheduledAt,
    isInOctWindow,
  ]);

  useEffect(() => {
    if (
      extractPeriodOptions.length > 0 &&
      !extractPeriodOptions.some((o: any) => o.value === report.extractPeriodKind)
    ) {
      setReport((prev) => ({ ...prev, extractPeriodKind: extractPeriodOptions[0].value }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [extractPeriodOptions, report.extractPeriodKind, report.scheduleKind]);
  
  // 表示候補から外れたら先頭候補に寄せる
  useEffect(() => {
    if (!extractPeriodOptions.some((o: any) => o.value === report.extractPeriodKind) && extractPeriodOptions.length > 0) {
      setReport((prev) => ({ ...prev, extractPeriodKind: extractPeriodOptions[0].value }));
    }
  }, [extractPeriodOptions, report.extractPeriodKind]);

  // --- 日時指定の下限 ---
  // 9/30 23:59 以前は「2025-10-01T00:00」未満を選択不可にする
  const scheduledAtMin = !isAuthorization ? "2025-10-01T00:00" : undefined;

  // useEffect
  useEffect(() => {
    const accountOptions:Option[] = [];
    let apolloList = apolloContex.apolloList.find((v) => apolloContex.current.accountGroupId === v.accountGroup.id);

    if (apolloList && apolloList.accountList) {
      for(let accountRow of apolloList.accountList) {
        var option:Option = {
          value: accountRow.id,
          label: accountRow.name,
        }
        accountOptions.push(option);
      }
      accountOptions.sort(function(a, b) {
          return b.value - a.value;
      });
      setAccountOptions(accountOptions);
    }

    setReport({ ...report, accountId: accountId })
  }, [])


  useEffect(() => {
    if (!isAuthorization && isBeforeCutoff) {
      setReport(prev => ({
        ...prev,
        startAt: moment("2025-10-01 00:00", "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss"),
        endAt:   moment("2025-10-31 23:59", "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss"),
      }));
    }
  }, []);

  useEffect(() => {
    if (report.accountId <= ZERO) return;

    setSelectedMenuValues([]);
    setSelectedCampaignKindValues([]);
    setSelectedCampaignValues([]);

    // 広告主アカウントキャンペーン取得
    const url = `${apollo_account_campaign_path}/${report.accountId}`;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        setmsg(setLoadingMessage(msg, false));
        // 広告主アカウントキャンペーンを設定
        setAccountCampaigns(response.data.result)
      } else {
        // エラー時、広告主アカウントキャンペーンを空配列で設定
        setAccountCampaigns([]);
        setmsg(setErrorMessageTypeAll(msg, MSG.ERROR_GET_ACCOUNT_CAMPAIGN));
      }
    }).catch(err => {
      // エラー時、広告主アカウントキャンペーンを空配列で設定
      setAccountCampaigns([]);
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, MSG.ERROR_GET_ACCOUNT_CAMPAIGN, msg, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    })
  }, [report.accountId])

  // キャンペーン一覧取得
  useEffect(() => {
    if (report.accountId <= ZERO) return;

    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_report_campaign_names_path}/${report.accountId}`
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        setmsg(setLoadingMessage(msg, false));
        if (!response.data.result) {
          setCampaignList([]);
        } else {
          setCampaignList(response.data.result);
        }
      } else {
        setmsg(setErrorMessageTypeAll(msg, MSG.ERROR_GET_CAMPAIGN));
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, MSG.ERROR_GET_CAMPAIGN, msg, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    })
  }, [report.accountId])

  useEffect(() => {
    if (report.accountId <= ZERO) return;

    setReport({ ...report, outputColumn: REPORT_OUTPUT_COLUMNS.MASTER.join(COMMA) })

    const fetchSetPoints = () => {
      const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_setpoints_path}/${report.accountId}`;
      ApolloAxios.get(url).then((response) => {
        if (response.data?.resultCode === RESULT_SETPOINT_ERROR) {
          setmsg(setErrorMessage(msg, `${MSG.ERROR_GET_SET_POINTS}${response?.data?.message ?? BLANK}`));
        } else if (response.data.result) {
          const newSetPoints: Option[] = [];
          const newDeletedSetPoints: Option[] = [];
          response.data?.result?.map(function (data: { setPointId: number, setPointName: string, setPointDeleteFlg: number }) {
            const option: Option = {
              value: data.setPointId,
              label: `${data.setPointId}${UNDER_SCORE}${data.setPointName}`,
            }
            if (data.setPointDeleteFlg === 0) {
              newSetPoints.push(option);
            } else {
              newDeletedSetPoints.push(option);
            }
          });
          setSetPoints(newSetPoints);
          setDeletedSetPoints(newDeletedSetPoints);
        }
      }).catch(err => {
        setmsg(setErrorMessage(msg, `${MSG.ERROR_GET_SET_POINTS}${err?.errmsg ?? BLANK}`));
      }).finally(() => {
        setmsg(setLoadingMessage(msg, false));
      });
    }

    const fetchAll = async () => {
      await Promise.all(
        [fetchSetPoints()]
      ).finally(() => {
      })
    }
    fetchAll();
  }, [report.accountId]);

  // 出力カラムマスタ取得
  useEffect(() => {
    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_report_output_columns_master_path}`
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        setmsg(setLoadingMessage(msg, false));
        const newOutputColumnsMaster: Option[] = [];
        response.data?.result?.map(function (data: { id: number, label: string}) {
          const option: Option = {
            value: data.id,
            label: data.label,
          }
          newOutputColumnsMaster.push(option);
        });
        setOutputColumnsMaster(newOutputColumnsMaster);
      } else {
        setmsg(setErrorMessageTypeAll(msg, MSG.ERROR_GET_REPORT_OUTPUT_COLUMNS_MASTER));
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, MSG.ERROR_GET_REPORT_OUTPUT_COLUMNS_MASTER, msg, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    })
  }, [])

  // 表示データ変更Effect
  useEffect(() => {
    createOption();
	}, [accountCampaigns]);

  useEffect(() => {
    createCampaignKindOptions();
	}, [selectedMenuValues]);

  useEffect(() => {
    createCampaignOptions();
	}, [selectedCampaignKindValues]);

  useEffect(() => {
    const resetReport = () => {
      if (report.reportKind === REPORT_KIND.DEMOGRAPHIC) {
        const updatedReport = { ...report };
        if (!(report.outputCaseLebel === OUTPUT_CASE_LEBEL.CAMPAIGN || report.outputCaseLebel === OUTPUT_CASE_LEBEL.ADGROUP)) {
          updatedReport.outputCaseLebel = OUTPUT_CASE_LEBEL.CAMPAIGN;
        }
        if (!(report.aggregationUnit === AGGREGATION_UNIT.SUM_TOTAL || report.aggregationUnit === AGGREGATION_UNIT.MONTH || report.aggregationUnit === AGGREGATION_UNIT.DAY)) {
          updatedReport.aggregationUnit = AGGREGATION_UNIT.SUM_TOTAL;
        }
        if (!(report.extractPeriodKind === EXTRACT_PERIOD_KIND.CURRENT_MONTH || report.extractPeriodKind === EXTRACT_PERIOD_KIND.LAST_MONTH || report.extractPeriodKind === EXTRACT_PERIOD_KIND.LAST_SEVEN_DAYS || report.extractPeriodKind === EXTRACT_PERIOD_KIND.CUSTOM)) {
          updatedReport.extractPeriodKind = EXTRACT_PERIOD_KIND.CURRENT_MONTH;
        }
        if (report.scheduleKind === SCHEDULE_KIND.REALTIME) {
          updatedReport.scheduleKind = SCHEDULE_KIND.REPEAT;
        }
        setReport(updatedReport);

        const filterMenuValues = selectedMenuValues.filter((menuId: number) => menuId !== MENU.OPTIMIZATION);
        setSelectedMenuValues(filterMenuValues);
        const filterCampaignValues = selectedCampaignValues.filter((list: any) => Number(list.value[ZERO]) !== MENU.OPTIMIZATION);
        setSelectedCampaignValues(filterCampaignValues);
      }
    };
    createOption();
    createCampaignOptions();
    resetReport();
	}, [report.reportKind]);

  // メニューオプション作成
  const createOption = () => {
    if (!(report && accountCampaigns && accountCampaigns.length > 0)) return;
    var local_menu_options: Option[] = []
    for (let menu of report.reportKind === REPORT_KIND.PERFORMANCE ? options_menu_kind_report : options_demographic_report_menu_kind) {
      if (accountCampaigns.some((item) => item.menuId === menu.value && item.campaignKindId === ZERO)) {
        local_menu_options.push(menu);
      }
    }
    setMenuOptions(local_menu_options);
  }

  // キャンペーン種別オプション作成
  const createCampaignKindOptions = () => {
    if (!(report && accountCampaigns && accountCampaigns.length > 0)) return;

    var local_campaign_kind_options: StrOption[] = []

    // パフォーマンス広告はキャンペーン種別IDを持っていないため、個別に判定
    if (accountCampaigns.some((item) => item.menuId === 1 && selectedMenuValues.includes(item.menuId))) {
      const options_menu_campaign_kind_performance = options_menu_campaign_kind.filter((item)=>{
        return item.value.startsWith("1_");
      });
      local_campaign_kind_options.push(...options_menu_campaign_kind_performance);
    }

    for (let optionsCampaignKind of options_menu_campaign_kind) {
      if (accountCampaigns.some((item) => `${item.menuId}${UNDER_SCORE}${item.campaignKindId}` === optionsCampaignKind.value
        && optionsCampaignKind.value != optionsMenuCampaignKindRTMValue
        && selectedMenuValues.includes(item.menuId))) {
        local_campaign_kind_options.push(optionsCampaignKind);
      }
    }
    setCampaignKindOptions(local_campaign_kind_options);
  }

  // キャンペーンオプション作成
  const createCampaignOptions = () => {
    if (!(report && accountCampaigns && accountCampaigns.length > 0)) return;

    var local_grouped_campaign_options: GroupedOption[] = []
    for (let menu of report.reportKind === REPORT_KIND.PERFORMANCE ? options_menu_kind_report : options_demographic_report_menu_kind) {
      var local_campaign_options: ColoredOption[] = []
      for (let campaign of campaignList) {
        if (menu.value === campaign.platform) {
          const platformCampaignKindValue = `${campaign.platform}${UNDER_SCORE}${campaign.platformCampaignKind}`;
          if (selectedCampaignKindValues.includes(platformCampaignKindValue)) {
            const campaignValue = `${platformCampaignKindValue}${UNDER_SCORE}${campaign.id}`;
            const campaignLabel = `${campaign.id}${UNDER_SCORE}${campaign.name}`;
            var opt: ColoredOption = {
              value: campaignValue,
              label: campaignLabel,
              color: menu.color,
            }
            local_campaign_options.push(opt);
          }
        }
      }

      var groupedOption: GroupedOption = {
        value: BLANK,
        label: menu.label,
        options: local_campaign_options,
      }
      local_grouped_campaign_options.push(groupedOption)
    }

    setGroupedCampaignOptions(local_grouped_campaign_options);
  }

  const handleCloseOutputColumn = () => {
    if (openOutputColumnDialog) setOpenOutputColumnDialog(false);
  }

  const handleOptionChange = (event: any) => {
    setReport({ ...report, extractFrequencyKind: Number(event.target.value) });
  };

  const onChangeCampaignOption = (selectedOptions: any) => {
    selectedOptions = sortByUnderscoreParts(selectedOptions);
    setSelectedCampaignValues(selectedOptions);

    setMenuCampaignkind(selectedMenuValues, selectedCampaignKindValues, selectedOptions);
  };

  const setMenuCampaignkind = (selectedMenuValues:number[], selectedCampaignKindValues:string[], selectedCampaignValues:any[]) => {
    const local_menu_campaign_kind:ReportMenuCampaignKind[] = [];
    selectedCampaignValues.forEach((option: any) => {
      const [menuIdStr, campaignKindIdStr, campaignIdStr] = option.value.split(UNDER_SCORE);
      const menuId = Number(menuIdStr);
      const campaignKindId = Number(campaignKindIdStr);
      const campaignId = Number(campaignIdStr);

      const opt: ReportMenuCampaignKind = {
        menuId,
        campaignKindId,
        campaignId,
      };
      local_menu_campaign_kind.push(opt);
    });

    selectedCampaignKindValues.forEach((option: string) => {
      const [menuIdStr, campaignKindIdStr] = option.split(UNDER_SCORE);
      const menuId = Number(menuIdStr);
      const campaignKindId = Number(campaignKindIdStr);

      const isSelected = local_menu_campaign_kind.some(
        (menu: ReportMenuCampaignKind) => menu.menuId === menuId && menu.campaignKindId === campaignKindId
      );

      if (!isSelected) {
        const opt: ReportMenuCampaignKind = {
          menuId,
          campaignKindId,
          campaignId: ZERO,
        };
        local_menu_campaign_kind.push(opt);
      }
    });

    selectedMenuValues.forEach((menuId: number) => {
      const isSelected = local_menu_campaign_kind.some(
        (menu: ReportMenuCampaignKind) => menu.menuId === menuId
      );

      if (!isSelected) {
        const opt: ReportMenuCampaignKind = {
          menuId,
          campaignKindId: ZERO,
          campaignId: ZERO,
        };
        local_menu_campaign_kind.push(opt);
      }
    });

    setReport({ ...report, menuCampaignKind: local_menu_campaign_kind });
  };

  const createCsv = (data:any, fileName:string) => {
    const blob = dataToCsvBlob(data)
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName ? fileName : "none.csv";
    link.click();
  }

  const dataToCsvBlob = (data: any): Blob => {
    // BASE64でコード
    let buf = Buffer.from(data, 'base64');
    const blob = new Blob([buf], {
        type: 'text/csv'
    })
    return blob
  }

  // 新規作成リクエスト
  const onSubmit = handleSubmit(() => {
    // バリデーション
    let hasError = false;

    // レポート種別
    if (report.reportKind === ZERO) {
      setError("reportKind", {
        type: "manual",
        message: MSG.VALIDATE_REQUIRED,
      })
      hasError = true;
    }
    // メニューキャンペーン種別
    if (report.menuCampaignKind.length <= ZERO) {
      setError("menuCampaignKind", {
        type: "manual",
        message: MSG.VALIDATE_REQUIRED,
      })
      hasError = true;
    }
    // 出力粒度
    if (report.outputCaseLebel === ZERO) {
      setError("outputCaseLebel", {
        type: "manual",
        message: MSG.VALIDATE_REQUIRED,
      })
      hasError = true;
    }

    // レポート種別が分析レポート選択時
    if (report.reportKind === REPORT_KIND.DEMOGRAPHIC) {
      // 出力粒度に広告は選択できない
      if (report.outputCaseLebel === OUTPUT_CASE_LEBEL.ADVERTISEMENT) {
        setError("outputCaseLebel", {
          type: "manual",
          message: MSG.VALIDATE_ADVERTISEMENT_NOT_ALLOWED,
        })
        hasError = true;
      }
      // 集計単位に時間は選択できない
      if (report.aggregationUnit === AGGREGATION_UNIT.HOUR) {
        setError("aggregationUnit", {
          type: "manual",
          message: MSG.VALIDATE_HOUR_NOT_ALLOWED,
        })
        hasError = true;
      }
    }

    // 期間指定がカスタム選択時、開始・終了の入力があるか
    if (report.extractPeriodKind === EXTRACT_PERIOD_KIND.CUSTOM) {
      if (!report.startAt || report.startAt === INVALID_DATE) {
        setError("startAt", {
          type: "manual",
          message: MSG.VALIDATE_START_AT,
        })
        hasError = true;
      } else if (!report.endAt || report.endAt === INVALID_DATE) {
        setError("endAt", {
          type: "manual",
          message: MSG.VALIDATE_END_AT,
        })
        hasError = true;
      }
      // 開始・終了の大小チェック
      if (!hasError) {
        if (moment(report.startAt) > moment(report.endAt)) {
          setError("startAt", {
            type: "manual",
            message: MSG.VALIDATE_START_DATE_BEFORE_END_DATE,
          })
          setError("endAt", {
            type: "manual",
            message: MSG.VALIDATE_END_DATE_AFTER_START_DATE,
          })
          hasError = true;
        } else {
          if (report.reportKind === REPORT_KIND.PERFORMANCE) {
            // 期間13ヶ月以内チェック
            var date13 = moment(report.startAt).add(1, 'years').add(1, 'months');
            if (date13 < moment(report.endAt)) {
              setError("endAt", {
                type: "manual",
                message: MSG.VALIDATE_DURATION_MONTHS,
              })
              hasError = true;
            }
          } else if (report.reportKind === REPORT_KIND.DEMOGRAPHIC) {
            const startAt = moment(report.startAt).startOf('day');
            const endAt = moment(report.endAt).startOf('day');
            if (endAt.diff(startAt, 'days') >= DEMOGRAPHIC_REPORT_MAX_PERIOD) {
              setError("startAt", {
                type: "manual",
                message: MSG.VALIDATE_DURATION_DAYS,
              })
              setError("endAt", {
                type: "manual",
                message: MSG.VALIDATE_DURATION_DAYS,
              })
              hasError = true;
            }
          }
        }
      }
    }

    // スケジュール種別が繰り返し選択時、曜日選択されているか
    if (effectiveScheduleKind === SCHEDULE_KIND.REPEAT) {
      if (report.extractFrequencyKind === EXTRACT_FREQUENCY_KIND.WEEKLY && report.extractWeek === INIT_EXTRACT_WEEK) {
        setError("extractWeek", {
          type: "manual",
          message: MSG.VALIDATE_EXTRACT_WEEK,
        })
        hasError = true;
      }

      if (!report.scheduledEndAt || report.scheduledEndAt === INVALID_DATE) {
        setError("scheduledEndAt", {
          type: "manual",
          message: MSG.VALIDATE_SCHEDULED_END_AT,
        })
        hasError = true;
      }

      const today = moment().startOf('day');
      const expiredAt = today.clone().add(REPORT_SCHEDULE_END_DATE_MAX, 'days').endOf('day');
      const scheduledEndAt = moment(report.scheduledEndAt);

      if (scheduledEndAt.diff(today) < ZERO) {
        setError("scheduledEndAt", {
          type: "manual",
          message: MSG.VALIDATE_SCHEDULED_END_AT_RESTRICTION,
        })
        hasError = true;
      }

      if (expiredAt.diff(scheduledEndAt) < ZERO) {
        setError("scheduledEndAt", {
          type: "manual",
          message: MSG.VALIDATE_SCHEDULE_END_DATE_MAX,
        })
        hasError = true;
      }
    }

    // スケジュール種別が日付指定時、時刻指定されているか
    if (effectiveScheduleKind === SCHEDULE_KIND.SCHEDULED) {
      if (!report.scheduledAt || report.scheduledAt === INVALID_DATE) {
        setError("scheduledAt", {
          type: "manual",
          message: MSG.VALIDATE_SCHEDULED_AT,
        })
        hasError = true;
      }

      const restrictedAt = moment().add(1, 'hour').startOf('hour');
      const scheduledAt = moment(report.scheduledAt);
      if (scheduledAt.diff(restrictedAt) < ZERO) {
        setError("scheduledAt", {
          type: "manual",
          message: MSG.VALIDATE_SCHEDULED_AT_RESTRICTION,
        })
        hasError = true;
      }
    }

    var workOutputColumn = filterOutputColumns(report.outputColumn, report.reportKind, report.outputCaseLebel)
    if (workOutputColumn === BLANK) {
      setError("outputColumn", {
        type: "manual",
        message: MSG.VALIDATE_OUTPUT_COLUMN,
      })
      hasError = true;
    }

    // 入力エラーがある場合は、リクエストを送らない
    if (hasError) return;

    // メニューキャンペーン種別のリストについて、画面で設定されている最小粒度に合わせ、不要な設定を除外する
    const isNotCampaignIdZeroMenuCampaignKind = report.menuCampaignKind.filter((x) => x.campaignId != ZERO);
    const isNotCampaignKindIdZeroMenuCampaignKind = report.menuCampaignKind.filter((x) => x.campaignKindId != ZERO);

    let newMenuCampaignKind: ReportMenuCampaignKind[] = [];
    if(isNotCampaignIdZeroMenuCampaignKind.length != ZERO) {
      newMenuCampaignKind = isNotCampaignIdZeroMenuCampaignKind;
    } else if(isNotCampaignKindIdZeroMenuCampaignKind.length != ZERO) {
      newMenuCampaignKind = isNotCampaignKindIdZeroMenuCampaignKind
    } else {
      newMenuCampaignKind = report.menuCampaignKind
    }

    // リクエスト
    setProgress(true);
    var workStartAt = report.startAt ? moment(report.startAt).toISOString() : null;
    var workEndAt = report.endAt ? moment(report.endAt).toISOString() : null;
    var workScheduledAt = report.scheduledAt ? moment(report.scheduledAt).toISOString() : null;
    var workScheduledEndAt = report.scheduledEndAt ? moment(report.scheduledEndAt).toISOString() : null;

    var executeLogData = createUserEventLogData(apolloContex, "レポート新規作成画面", "作成", null, null, report);
    ApolloEventRecord(executeLogData);

    const reportSettingCreateRequest: ReportSettingRequest = {
      reportName: report.reportName === BLANK ? UNNAMED_REPORT : report.reportName,
      accountgroupId: accountGroupId,
      accountId: report.accountId,
      reportKind: report.reportKind,
      menuCampaignKind: newMenuCampaignKind,
      outputCaseLebel: report.outputCaseLebel,
      aggregationUnit: report.aggregationUnit,
      option: report.reportKind === REPORT_KIND.DEMOGRAPHIC ? report.option : null,
      extractPeriodKind: report.extractPeriodKind,
      startAt: report.extractPeriodKind === EXTRACT_PERIOD_KIND.CUSTOM ? workStartAt : null,
      endAt: report.extractPeriodKind === EXTRACT_PERIOD_KIND.CUSTOM ? workEndAt : null,
      scheduleKind: effectiveScheduleKind,
      extractFrequencyKind: effectiveScheduleKind === SCHEDULE_KIND.REPEAT ? report.extractFrequencyKind : ZERO,
      extractDay: effectiveScheduleKind === SCHEDULE_KIND.REPEAT && report.extractFrequencyKind === EXTRACT_FREQUENCY_KIND.MONTHLY ? report.extractDay : ZERO,
      extractWeek: effectiveScheduleKind === SCHEDULE_KIND.REPEAT && report.extractFrequencyKind === EXTRACT_FREQUENCY_KIND.WEEKLY ? report.extractWeek : BLANK,
      scheduledAt: effectiveScheduleKind === SCHEDULE_KIND.SCHEDULED ? workScheduledAt : null,
      scheduledEndAt: effectiveScheduleKind === SCHEDULE_KIND.REPEAT ? workScheduledEndAt : null,
      outputColumn: workOutputColumn,
      status: ZERO,
      repeatStatus: effectiveScheduleKind === SCHEDULE_KIND.REPEAT ? REPEAT_STATUS.RUNNING : ZERO,
    }

    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_report_setting_path}/${accountId}`
    ApolloAxios.post(url, reportSettingCreateRequest).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        handleSuccessEventLog(executeLogData);
        if (effectiveScheduleKind === SCHEDULE_KIND.REALTIME) {
          if (response.data.result.reportStatus === REPORT_STATUS.SUCCESS) {
            setmsg(setSuccessMessage(msg, MSG.SUCCESS_REPORT_REALTIME));
            createCsv(response.data.resultCsv, response.data.result.reportFileName);
          } else {
            setmsg(setWarningMessage(msg, MSG.WARNING_REPORT_REALTIME));
          }
        } else {
          setmsg(setSuccessMessage(msg, MSG.SUCCESS_POST_REPORT_SETTING));
          handleGoback();
        }
      } else if (response.data.resultCode === RESULT_CODE.BUSY_ERROR) {
        setmsg(setWarningMessage(msg, MSG.WARNING_REPORT_REALTIME_BUSY));
      } else {
        handleFailureEventLog(executeLogData);
        if (effectiveScheduleKind === SCHEDULE_KIND.REALTIME) {
          setmsg(setErrorMessage(msg, MSG.ERROR_REPORT_REALTIME));
        } else {
          setmsg(setErrorMessage(msg, MSG.ERROR_POST_REPORT_SETTING));
        }
      }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, MSG.ERROR_POST_REPORT_SETTING, msg, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        setProgress(false);
      });
  });

  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80} />
      </Backdrop>

      <ApolloBreadcrumbs bread_no={77} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
        platform={""} />
      <React.Fragment>
      <CustomizedSnackbars />
      <form noValidate onSubmit={onSubmit}>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <ApolloBasicSelect
                  id="accountId"
                  label="広告主アカウント名"
                  options={accountOptions}
                  value={report.accountId}
                  control={control}
                  errors={errors}
                  setState={(e: any) => setReport({ ...report, accountId: e })}
                />
              </Grid>

              <Grid item xs={12}>
                <ApolloBasicSelect
                  id="reportKind"
                  label="レポート種別"
                  options={options_report_kind}
                  value={report.reportKind}
                  control={control}
                  errors={errors}
                  setState={(e: any) => setReport({ ...report, reportKind: e })}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicTextField
                  id="reportName"
                  label="レポート名"
                  value={report.reportName}
                  error={errors.reportName}
                  inputRef={register({
                    maxLength: {
                      value: 255,
                      message: "255文字以内で入力して下さい。"
                    },
                    validate: (e: string) => {
                      const errorMessage = checkInvalidCharForReportName(e)
                      if(errorMessage) {
                        return errorMessage
                      }
                    },
                  })}
                  setState={(e: any) => setReport({ ...report, reportName: e })}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  メニュー選択
                </Typography>
                <div>
                  <ApolloBasicSelect
                    id="menu"
                    label=""
                    options={menuOptions}
                    value={selectedMenuValues}
                    control={control}
                    errors={errors}
                    isMulti={true}
                    closeMenuOnSelect={false}
                    rules={{
                        required: "一つ以上のメニューを選択して下さい",
                    }}
                    setState={(e: any) => {
                      const setVals = e ? e.map((target: any) => {
                        return target.value
                      }) : []
                      setSelectedMenuValues(setVals);

                      const selectedMenuIds = setVals
                      const filterCampaignKindValues = selectedCampaignKindValues.filter((list: string) => selectedMenuIds.includes(Number(list[ZERO])))
                      setSelectedCampaignKindValues(filterCampaignKindValues)
                      const filterCampaignValues = selectedCampaignValues.filter((list: any) => selectedMenuIds.includes(Number(list.value[ZERO])))
                      setSelectedCampaignValues(filterCampaignValues)

                      setMenuCampaignkind(setVals, selectedCampaignKindValues, selectedCampaignValues);
                    }}
                    selectStyle={{ maxHeight: "70px", overflowY: "scroll"}}
                  />
                </div>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  キャンペーン種別
                </Typography>
                <div>
                  <ApolloBasicSelect
                    id="campaignKind"
                    label=""
                    options={campaignKindOptions}
                    value={selectedCampaignKindValues}
                    control={control}
                    errors={errors}
                    isMulti={true}
                    closeMenuOnSelect={false}
                    setState={(e: any) => {
                      const setVals = e ? e.map((target: any) => {
                        return target.value
                      }) : []
                      setSelectedCampaignKindValues(setVals);

                      const selectedCampaignKindVals = setVals
                      const filterCampaignValues = selectedCampaignValues.filter((list: any) => selectedCampaignKindVals.includes(list.value.slice(ZERO, NUMBER.THREE)))
                      setSelectedCampaignValues(filterCampaignValues)

                      setMenuCampaignkind(selectedMenuValues, setVals, selectedCampaignValues);
                    }}
                    selectStyle={{ maxHeight: "70px", overflowY: "scroll"}}
                  />
                </div>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  キャンペーン名
                </Typography>
                <div>
                  <Select
                    menuPosition={'fixed'}
                    closeMenuOnSelect={false}
                    isMulti
                    isSearchable
                    value={selectedCampaignValues}
                    onChange={onChangeCampaignOption}
                    options={groupedCampaignOptions}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        maxHeight: "70px", overflowY: "scroll"
                      }),
                      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                        return {
                          ...styles,
                          backgroundColor: isDisabled
                          ? undefined
                          : isSelected
                          ? data.color
                          : isFocused
                          ? "#BCD4FF"
                          : undefined,
                          color: isDisabled
                            ? '#ccc'
                            : data.color,
                          cursor: isDisabled ? 'not-allowed' : 'default',
                          ':active': {
                            ...styles,
                            backgroundColor: !isDisabled
                              ? data.color
                              : isSelected,
                          },
                        };
                      },
                      multiValue: (styles, { data }) => {
                        return {
                          ...styles,
                        };
                      },
                      multiValueLabel: (styles, { data }) => ({
                        ...styles,
                        color: data.color,
                      }),
                      multiValueRemove: (styles, { data }) => ({
                        ...styles,
                        color: data.color,
                        ':hover': {
                          backgroundColor: data.color,
                          color: 'white',
                        },
                      }),
                      menuPortal: base => ({...base, zIndex: 9999}),
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={6}>
                <ApolloBasicSelect
                  id="outputCaseLebel"
                  label="出力粒度"
                  options={report.reportKind === REPORT_KIND.PERFORMANCE ? options_performance_report_ad_kind : options_demographic_report_output_case_lebel}
                  value={report.outputCaseLebel}
                  control={control}
                  errors={errors}
                  setState={(e: any) => setReport({ ...report, outputCaseLebel: e })}
                />
              </Grid>

              <Grid item xs={6}>
                <ApolloBasicSelect
                  id="aggregationUnit"
                  label="集計単位"
                  options={report.reportKind === REPORT_KIND.PERFORMANCE ? options_performance_report_totaling_period_kind : options_analysis_report_totaling_period_kind}
                  value={report.aggregationUnit}
                  control={control}
                  errors={errors}
                  rules={{
                    required: "必須入力項目です。",
                  }}
                  setState={(e: any) => setReport({ ...report, aggregationUnit: e })}
                />
              </Grid>
              {
                // レポート種別が2: 実績レポートの場合のみ表示
                report.reportKind === REPORT_KIND.DEMOGRAPHIC
                  ? <Grid item xs={12}>
                    <ApolloBasicRadio
                      id="option"
                      label="オプション"
                      options={options_analysis_report_option}
                      value={report.option}
                      control={control}
                      errors={errors}
                      setState={(e: any) => setReport({ ...report, option: Number(e) })}
                    />
                  </Grid>
                  : null
              }
              <Grid item xs={5}>
                <ApolloBasicRadio
                  id="extractPeriodKind"
                  label="期間指定"
                  options={extractPeriodOptions}
                  value={report.extractPeriodKind}
                  control={control}
                  errors={errors}
                  setState={(e: any) => setReport({ ...report, extractPeriodKind: Number(e) })}
                />
              </Grid>
              {/* 期間指定を5(カスタム)選択時に、開始/終了入力表示 */}
              {report.extractPeriodKind === EXTRACT_PERIOD_KIND.CUSTOM
                ? <>
                <ApolloBasicPeriod
                  key={updatePriodItemTrigger.format()}
                  startDate={{
                    id: "startAt",
                    label: "開始",
                    value: moment(report.startAt).format("YYYY-MM-DDTHH:mm"),
                    inputProps: {
                      ...(isAuthorization
                        ? {}
                        : { min: "2025-10-01T00:00" }),
                    },
                    errors: errors.startAt,
                    setState: (e: any) => {
                      const next = moment(
                        e,
                        ["YYYY-MM-DDTHH:mm", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601],
                        true
                      );
                    
                      // 非管理者 & 2025/10/01 00:00 未満なら無視（state を更新しない）
                      setPriodStarMessageInfo(BLANK)

                      const cutoff = moment(  "2025-10-01 00:00", "YYYY-MM-DD HH:mm");

                      if (!isAuthorization && (!next.isValid() || next.isBefore(cutoff))) {

                        const current = moment()
                        const nextValue = current.isBefore(cutoff) ? cutoff.format("YYYY-MM-DD HH:mm:ss") : startThisMonth

                        setReport({ ...report, startAt: nextValue });
                        setPriodStarMessageInfo(REPORT_PERIOD_AUTO_CHANGE_MSG)
                        setmsg(setWarningMessage(msg, REPORT_PERIOD_START_DEFAULT_VALUE_SET_MSG));
                      } else {
                        setReport({ ...report, startAt: next.format("YYYY-MM-DD HH:mm:ss") });
                      }
                      setUpdatePriodItemTrigger(moment())
                      const startAt = moment(e).startOf('day');
                      const endAt = moment(report.endAt).startOf('day');
                      if (report.reportKind === REPORT_KIND.DEMOGRAPHIC && endAt.diff(startAt, 'days') >= DEMOGRAPHIC_REPORT_MAX_PERIOD) {
                        setError("startAt", {
                          type: "manual",
                          message: MSG.VALIDATE_DURATION_DAYS,
                        })
                      } else {
                        clearErrors()
                      }
                    },
                    message: priodStarMessageInfo

                  }}
                  endDate={{
                    id: "endAt",
                    label: "終了",
                    value: moment(report.endAt).format("YYYY-MM-DDTHH:mm"),
                    inputProps: {
                      ...(isAuthorization
                        ? {}
                        : { min: "2025-10-01T00:00" }),
                    },
                    errors: errors.endAt,
                    setState: (e: any) => {
                      const next = moment(
                        e,
                        ["YYYY-MM-DDTHH:mm", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601],
                        true
                      );
                    
                      setPriodEndessageInfo(BLANK)

                      const cutoff = moment("2025-10-01 00:00", "YYYY-MM-DD HH:mm");

                      if (!isAuthorization && (!next.isValid() || next.isBefore(cutoff))) {

                        const current = moment()
                        const nextValue = current.isBefore(cutoff) ? moment("2025-10-31 23:59", "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss") : endThisMonth

                        setPriodEndessageInfo(REPORT_PERIOD_AUTO_CHANGE_MSG)
                        setReport({ ...report, endAt: nextValue});
                        setmsg(setWarningMessage(msg, REPORT_PERIOD_END_DEFAULT_VALUE_SET_MSG));
                      } else {
                        setReport({ ...report, endAt: next.format("YYYY-MM-DD HH:mm:ss") });
                      }
                      setUpdatePriodItemTrigger(moment())
                      const startAt = moment(report.startAt).startOf('day');
                      const endAt = moment(e).startOf('day');
                      if (report.reportKind === REPORT_KIND.DEMOGRAPHIC && endAt.diff(startAt, 'days') >= DEMOGRAPHIC_REPORT_MAX_PERIOD) {
                        setError("endAt", {
                          type: "manual",
                          message: MSG.VALIDATE_DURATION_DAYS,
                        })
                      } else {
                        clearErrors()
                      }
                    },
                    message: priodEndessageInfo
                  }}
                isAuthorization={isAuthorization}
                />
                </>
                : null}
              {!isAuthorization && (
                <Grid item xs={12}>
                  <Typography variant="caption" color="textSecondary" style={{ fontWeight: 700 }}>
                    集計範囲に指定可能なのは2025年10月1日以降です。2025年9月30日以前を集計範囲とする場合は、
                    <Button
                      type="button"
                      onClick={goToReport}
                      color="primary"
                      style={{ padding: 0, minWidth: "auto", textDecoration: "underline", fontWeight: "inherit" }}
                    >
                      レポート管理 
                    </Button>
                    をご利用下さい
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12}>
                <ApolloBasicRadio
                  id="scheduleKind"
                  label={"作成タイミング"}
                  options={scheduleKindOptions}
                  value={effectiveScheduleKind}
                  control={control}
                  errors={errors}
                  setState={(e: any) => {
                    const nextKind = Number(e);

                    if (nextKind === SCHEDULE_KIND.SCHEDULED) {
                      // 9/30以前かつ isAuthorization=false のときは固定で 2025/10/01 10:00 を入れる
                      if (!isAuthorization && isBeforeCutoff) {
                        setReport(prev => ({
                          ...prev,
                          scheduleKind: nextKind,
                          scheduledAt: "2025-10-01 10:00:00",
                        }));
                        return;
                      }
                      setReport(prev => ({ ...prev, scheduleKind: nextKind }));
                    } else {
                      setReport(prev => ({ ...prev, scheduleKind: nextKind }));
                    }
                  }}
                />
              </Grid>
            </Grid>
            {!isAuthorization && (
                <Grid item xs={12}>
                  <Typography variant="caption" color="textSecondary" style={{ fontWeight: 700 }}>
                    2025年10月以降に作成処理が行われます。現在は現行のレポート管理からの移行を目的として、レポート作成指定のみが可能です。
                  </Typography>
                </Grid>
              )}
            <Grid item xs={12}>
              <Grid item xs={6} style={{display: "flex"}}>
                <ApolloDialogButton setOpen={setOpenOutputColumnDialog}>
                    <Button type="button" color="primary" variant="contained" className={classes.button}>
                      {"出力カラム設定"}
                    </Button>
                </ApolloDialogButton>
                {
                  isSetOutputColumns(report.outputColumn, report.reportKind, report.outputCaseLebel)
                  ?
                  <Typography variant="subtitle1" gutterBottom component="div" className={classes.button} style={{color: "red"}}>
                    {"設定あり"}
                  </Typography>
                  : null
                }
                <ErrorMessage
                  errors={errors}
                  name={"outputColumn"}
                  style={{marginTop: "28px"}}
                  as={<Typography variant="caption" className={classes.errorMessage}/>}
                />
              </Grid>
              <Typography variant="caption">
                {"※広告主アカウント名を変更した場合、出力カラム設定は初期化されますのでご注意ください。"}
              </Typography>
            </Grid>
          </CardContent>

          {
            effectiveScheduleKind  === SCHEDULE_KIND.REPEAT || effectiveScheduleKind  === SCHEDULE_KIND.SCHEDULED
            ?
          <Card className={classes.root} square variant="outlined" style={{padding:10, marginLeft: "10px", marginRight: "10px"}}>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography style={{fontSize: "20px"}} variant="subtitle1" gutterBottom component="div">
                    レポート予約設定詳細
                  </Typography>
                </Grid>
                {
                  effectiveScheduleKind  === SCHEDULE_KIND.REPEAT
                  ?
                  <>
                  <Grid item xs={2} style={{marginLeft: "15px"}}>
                      <Typography variant="subtitle1" gutterBottom component="div">
                        抽出頻度
                      </Typography>
                      <RadioGroup style={{marginLeft: "17px"}} value={report.extractFrequencyKind} onChange={handleOptionChange} row>
                        {options_extract_frequency_kind.map((v) => (
                          <FormControlLabel
                            value={v.value}
                            control={<Radio/>}
                            label={v.label}
                          />
                        ))}
                      </RadioGroup>
                  </Grid>
                  </>
                  : null
                }

                <Grid item xs={12} style={{marginLeft: "15px"}}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                        スケジュール
                    </Typography>
                </Grid>

                {
                effectiveScheduleKind === SCHEDULE_KIND.REPEAT && report.extractFrequencyKind === EXTRACT_FREQUENCY_KIND.WEEKLY
                  ?
                  <Grid item xs={12} style={{marginLeft: "30px"}}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      曜日指定
                    </Typography>
                    {weekKeys.map((weekKey, index) => {
                      return (
                        <ApolloBasicCheck
                          id={`extractWeek${index}`}
                          key={index}
                          label={weekKey}
                          checked={extractWeekJson[index]}
                          labelPlacement={"end"}
                          setState={
                            (e: any) => {
                              setReport({
                                ...report,
                                extractWeek: JSON.stringify(extractWeekJson.map((val, idx) => index === idx ? (e ? CHECKBOX_STATE.CHECKED : CHECKBOX_STATE.UNCHECKED) : (val ? CHECKBOX_STATE.CHECKED : CHECKBOX_STATE.UNCHECKED)))
                              })
                            }
                          }
                        />
                      )
                    })}
                    <ErrorMessage
                      errors={errors}
                      name={"extractWeek"}
                      as={<Typography variant="caption" className={classes.errorMessage}/>}
                    />
                  </Grid>
                : effectiveScheduleKind === SCHEDULE_KIND.SCHEDULED
                  ? <Grid item xs={3} style={{marginLeft: "30px"}}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      日時指定
                    </Typography>
                    <ApolloBasicTextField
                      id="scheduledAt"
                      label=""
                      value={moment(report.scheduledAt).format("YYYY-MM-DDTHH:00")}
                      type="datetime-local"
                      error={errors.scheduledAt}
                      setState={(e: any) => {
                        const next = moment(
                          e,
                          ["YYYY-MM-DDTHH:mm", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601],
                          true
                        );
                      
                        const cutoff = moment("2025-10-01 00:00", "YYYY-MM-DD HH:mm");
                        if (!isAuthorization && (!next.isValid() || next.isBefore(cutoff))) {
                          return;
                        }
                      
                        setReport({ ...report, scheduledAt: next.format("YYYY-MM-DD HH:mm:ss") });
                      }}
                      inputProps={{
                        step: 1800,
                        views: ['year', 'month', 'day', 'hour'],
                        ...(scheduledAtMin ? { min: scheduledAtMin } : {}),
                      }}
                    />
                  </Grid>
                  : null
                }

                {
                  effectiveScheduleKind === SCHEDULE_KIND.REPEAT && report.extractFrequencyKind === EXTRACT_FREQUENCY_KIND.MONTHLY
                  ?
                  <>
                  <Grid item xs={1} style={{marginLeft: "30px"}}>
                    <ApolloBasicSelect
                      id={"extractDay"}
                      label={"日付指定"}
                      options={options_extract_day}
                      value={report.extractDay}
                      control={control}
                      errors={errors}
                      setState={(e: any) => setReport({ ...report, extractDay: e })}
                    />
                  </Grid>
                  <Grid item xs={1} style={{marginTop: "35px"}}>
                    <Typography style={{fontSize: "20px"}} variant="subtitle1" gutterBottom component="div">
                        {DAY}
                    </Typography>
                  </Grid>
                  </>
                : null
                }

                {
                  effectiveScheduleKind === SCHEDULE_KIND.REPEAT
                  ?
                  <Grid container spacing={3}>
                    <Grid item xs={3} style={{marginLeft: "15px", marginTop: "20px"}}>
                      <ApolloBasicTextField
                        id="scheduledEndAt"
                        label="スケジュールの終了日"
                        value={moment(report.scheduledEndAt).format("YYYY-MM-DD")}
                        type="date"
                        error={errors.scheduledEndAt}
                        setState={(e: any) => setReport({ ...report, scheduledEndAt: moment(e).format("YYYY-MM-DD HH:00:00") })}
                        inputProps={{
                          inputProps: { step: 1800 , views:['year', 'month', 'day', 'hour']},
                        }}
                      />
                    </Grid>
                  </Grid>
                  : null
                }
              </Grid>
            </CardContent>
          </Card>
            : null
          }

          <CardActions>
            <Button
              type="submit"
              color="primary"
              className={classes.button}
              onClick={() => clearErrors()}
              variant="contained"
            >
              作成
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleGoback}
              className={classes.button}
            >
              戻る
            </Button>
          </CardActions>
        </Card>
      </form>
      <ApolloDialog open={openOutputColumnDialog} setOpen={setOpenOutputColumnDialog} onClose={handleCloseOutputColumn}>
        <ApolloOutputColumnDialog
          reportKind={report.reportKind}
          outputCaseLebel={report.outputCaseLebel}
          outputColumn={report.outputColumn}
          outputColumnsMaster={outputColumnsMaster}
          setPoints={setPoints}
          deletedSetPoints={deletedSetPoints}
          report={report}
          setReport={setReport}
          handleClose={handleCloseOutputColumn}
        />
      </ApolloDialog>
    </React.Fragment>
    </GenericTemplate>
  )
}

export const createUserEventLogData = (
  apolloContex: any,
  displayName: string,
  actionType: string,
  reportSettingId: string | null,
  beforeInfo: ReportSetting | null,
  afterInfo: ReportSetting | null,
) => {
  const items: ItemList[] = [
    createUserLogItemListFromString("reportName", "reportName", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("accountId", "accountId", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("reportKind", "reportKind", beforeInfo, afterInfo),
    createUserLogItemListFromObject("menuCampaignKind", "menuCampaignKind", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("outputCaseLebel", "outputCaseLebel", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("aggregationUnit", "aggregationUnit", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("extractPeriodKind", "extractPeriodKind", beforeInfo, afterInfo),
    createUserLogItemListFromDate("startAt", "startAt", beforeInfo, afterInfo, FORMAT_YYYY_MM_DD_HHmmss),
    createUserLogItemListFromDate("endAt", "endAt", beforeInfo, afterInfo, FORMAT_YYYY_MM_DD_HHmmss),
    createUserLogItemListFromNumber("scheduleKind", "scheduleKind", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("extractFrequencyKind", "extractFrequencyKind", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("extractDay", "extractDay", beforeInfo, afterInfo),
    createUserLogItemListFromString("extractWeek", "extractWeek", beforeInfo, afterInfo),
    createUserLogItemListFromDate("scheduledAt", "scheduledAt", beforeInfo, afterInfo, FORMAT_YYYY_MM_DD_HHmmss),
    createUserLogItemListFromDate("scheduledEndAt", "scheduledEndAt", beforeInfo, afterInfo, FORMAT_YYYY_MM_DD_HHmmss),
    createUserLogItemListFromString("outputColumn", "outputColumn", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("status", "status", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("repeatStatus", "repeatStatus", beforeInfo, afterInfo),
  ];

  var executeLogData: LogData = {
    eventDate:  moment().format(FORMAT_YYYY_MM_DD_HHmmss),
    logType: "execute", // ログ種別 実行：execute, 結果：result
    result: "", // 実行結果 成功 / 失敗 ※実行時は空文字
    userID: apolloContex.userprofile.userId,
    userName:  apolloContex.userprofile.userName,
    accessToken:  apolloContex.accesstoken,
    displayName: displayName,
    category: "レポート2", // 操作対象 キャンペーン / セグメント etc...
    actionType: actionType,
    accountGroupID: apolloContex.current.accountGroupId,
    accountGroupName: apolloContex.current.accountGroupName,
    accountID: apolloContex.current.accountId,
    accountName: apolloContex.current.accountName,
    campaignID: "", // キャンペーンID
    campaignName: "", // キャンペーン名
    adGroupID: "", // 広告グループID
    adGroupName: "", // 広告グループ名
    targetID: reportSettingId ? reportSettingId : "", // 操作を行うデータのID 実行時は空文字
    targetName: "", // 操作を行うデータの名称 実行時は空文字
    menu: "",
    itemList: items,
  };

  return executeLogData
}

export default ReportCreate;